import * as React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 27"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="6fvibmu36b">
        <stop stopColor="#F9945B" offset="0%" />
        <stop stopColor="#F94B23" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="g6fhpq3h9a">
        <stop stopColor="#FFB083" offset="0%" />
        <stop stopColor="#FF7A5C" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="15.078%"
        y1="26.383%"
        x2="91.089%"
        y2="75.437%"
        id="tc4zf9ltvd"
      >
        <stop stopColor="#FFE9E1" offset="0%" />
        <stop stopColor="#FFE9E1" offset="100%" />
      </linearGradient>
      <filter
        x="-109.1%"
        y="-133.3%"
        width="318.2%"
        height="366.7%"
        filterUnits="objectBoundingBox"
        id="tr3fk6wdtc"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={2}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.976470588 0 0 0 0 0.321568627 0 0 0 0 0.156862745 0 0 0 1 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M11.5.821c2.85 0 5.43 1.155 7.297 3.023a10.287 10.287 0 0 1 3.023 7.297c0 2.468-1.54 5.495-3.44 8.161-2.494 3.499-5.655 6.52-6.88 6.52-1.225 0-4.386-3.021-6.88-6.52-1.9-2.666-3.44-5.693-3.44-8.161 0-2.85 1.155-5.43 3.023-7.297A10.287 10.287 0 0 1 11.5.82Z"
        stroke="url(#g6fhpq3h9a)"
        fill="url(#6fvibmu36b)"
      />
      <g
        filter="url(#tr3fk6wdtc)"
        transform="translate(6 7)"
        fill="url(#tc4zf9ltvd)"
        fillRule="nonzero"
      >
        <path d="M.643 3.53h.576v3.173H.643V3.53ZM.94 6.32a.61.61 0 0 1 .562.405.698.698 0 0 1-.132.718.579.579 0 0 1-.664.143.658.658 0 0 1-.375-.608c0-.174.063-.342.18-.465A.579.579 0 0 1 .94 6.32Zm1.914-1.94h5.4c.087 0 .173.038.234.107a.372.372 0 0 1 .098.253v3.015c0 .199-.157.36-.332.503 0 0-1.41.742-2.789.742-1.32 0-2.61-.742-2.61-.742-.229-.152-.333-.353-.333-.551V4.74c0-.095.035-.187.098-.253a.315.315 0 0 1 .234-.106Zm.542.468h4.316a.27.27 0 0 1 .265.273v2.297c0 .152-.025.271-.265.384 0 0-1.126.566-2.228.566-1.055 0-2.088-.566-2.088-.566-.23-.084-.265-.27-.265-.419V5.121c0-.152.118-.273.265-.273ZM5.95.108l4.864 2.815c.248.143.248.376 0 .522L5.95 6.26a.997.997 0 0 1-.9 0L.186 3.445c-.248-.144-.248-.377 0-.522L5.05.107a.997.997 0 0 1 .9 0ZM5.87.798l3.939 2.148c.201.11.201.288 0 .398l-3.94 2.148a.846.846 0 0 1-.728 0L1.203 3.345c-.202-.11-.202-.288 0-.398L5.142.799a.857.857 0 0 1 .727 0Z" />
      </g>
    </g>
  </svg>
)

export default SvgComponent
